import McpPermission from '@/bundles/Roles/models/McpPermission';
import { McpRoleTypeEnum } from '@/bundles/Roles/types';
import { PREDEFINED_MCP_ROLE_NAMES } from '@/bundles/Roles/constants/mcp';
import { Nullable } from '@/utils/types';

export interface IMcpRoleData {
  id: number;
  name: string;
  description?: Nullable<string>;
  permissions?: McpPermission[];
  userCount?: Nullable<number>;
  updatedAt?: Nullable<string>;
  updatedBy?: Nullable<string>;
}

export default class McpRole {
  id: number;
  name: string;
  description: Nullable<string>;
  permissions: McpPermission[];
  userCount: Nullable<number>;
  updatedAt: Nullable<string>;
  updatedBy: Nullable<string>;

  constructor (data: IMcpRoleData) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description ?? null;
    this.permissions = data.permissions ?? [];
    this.userCount = data.userCount ?? null;
    this.updatedAt = data.updatedAt ?? null;
    this.updatedBy = data.updatedBy ?? null;
  }

  get roleType (): McpRoleTypeEnum {
    return PREDEFINED_MCP_ROLE_NAMES.includes(this.name)
      ? McpRoleTypeEnum.PREDEFINED
      : McpRoleTypeEnum.CUSTOM;
  }

  get isPredefined (): boolean {
    return this.roleType === McpRoleTypeEnum.PREDEFINED;
  }

  get permissionIds (): number[] {
    return this.permissions.map((permission) => permission.id);
  }
}
